module.exports = __webpack_public_path__ + "img/banner-bg-3.04faec55.png";